<template>
    <input
        ref="input"
        type="file"
        @change="onFileChange"
        :multiple="multiple"
        :accept="accept"
        :class="{'input-not-visible': !visible }"
    >
</template>

<script>
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { Capacitor } from '@capacitor/core';

export default {
    name: 'uploadfile',
    data () {
        return {
            isNative: false
        };
    },
    mounted () {
        this.language = this.$getLang();
        // Check if running on native platform (Android/iOS)
        this.isNative = Capacitor.isNativePlatform();
    },
    methods: {
        async show () {
            // Use Capacitor Camera API on native platforms for single file uploads
            // This uses Android Photo Picker on Android 13+ which doesn't require READ_MEDIA permissions
            if (this.isNative && !this.multiple) {
                try {
                    const image = await Camera.getPhoto({
                        quality: 90,
                        allowEditing: false,
                        resultType: CameraResultType.DataUrl,
                        source: CameraSource.Photos // Use photo picker instead of camera
                    });

                    if (image.dataUrl) {
                        // Convert data URL to File object for compatibility with existing code
                        const response = await fetch(image.dataUrl);
                        const blob = await response.blob();
                        const file = new File([blob], image.path || 'image.jpg', { type: blob.type || 'image/jpeg' });

                        // Create a DataTransfer object to simulate file input
                        const dataTransfer = new DataTransfer();
                        dataTransfer.items.add(file);

                        // Assign files to input element so parent components can access via $el.files[0]
                        this.$refs.input.files = dataTransfer.files;

                        // Trigger the change event to maintain compatibility
                        this.createImage(file);
                    }
                } catch (error) {
                    console.error('Error picking image:', error);
                    // Fallback to file input if camera picker fails (e.g., user cancelled)
                    if (error.message !== 'User cancelled photos picker.' && !error.message.includes('cancel')) {
                        this.$refs.input.click();
                    }
                }
            } else {
                // Use HTML file input for web or multiple file selection
                this.$refs.input.click();
            }
        },

        onFileChange (e) {
            let files = e.target.files || e.dataTransfer.files;
            console.log('files', files);
            if (!files.length) {
                return;
            }
            // For multiple files, emit all files, otherwise just the first
            if (this.multiple) {
                // Emit all files for multiple selection
                let allFiles = [];
                for (let i = 0; i < files.length; i++) {
                    allFiles.push(files[i]);
                }
                this.$emit('change', allFiles);
            } else {
                this.createImage(files[0]);
            }
        },

        createImage (file) {
            /* eslint-disable no-undef */
            let reader = new FileReader();
            let vm = this;
            console.log('createImage', reader, file);
            reader.onload = (e) => {
                let image = e.target.result;
                let data = {};
                data[vm.name] = image;
                console.log('data', data);
                vm.$emit('change', data);
            };
            reader.readAsDataURL(file);
        }
    },
    props: {
        name: String,
        visible: Boolean,
        multiple: [Boolean, String],
        accept: {
            type: String,
            default: 'image/*'
        }
    }
};
</script>
<style scoped>
    .input-not-visible {
        opacity: 0;
        visibility: hidden;
    }
</style>



// WEBPACK FOOTER //
// src/components/elements/Uploadfile.vue